import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InquiryService } from '../../../shared/API-Service/services/inquiry.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../app/shared/components/base/base.component'
@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.component.html',
  styleUrls: ['./inquiry.component.css']
})
export class InquiryComponent extends BaseComponent implements OnInit {
  Inquiry: any;

  constructor(private InquiryService:InquiryService,private _Router:Router) { super()}


  ngOnInit(): void {
    this.getInquiry();
    
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getInquiry();

  }
  getInquiry(){
    // const data={
    //   "maxResultCount": this.pager.maxResultCount,
    //   "skipCount": this.pager.skipCount,
    // }
    // this.pager.isViewed= true
    this.InquiryService.GetInquiryPaged(this.pager).subscribe((res) => {
      this.Inquiry = res.data.items
      this.totalCount=res.data.totalCount
      // this.totalCount=res.data.totalCount;
    
    },(err)=>{
    },() =>{
    });
  }
  // update(id){
  //   console.log(id);
  //   //this.PartnersService.Data.next(data);
  //   // this._Router.navigate(['/content/admin/insert-partner']);
  //   this._Router.navigate(['/content/admin/update-partner',id]);
  //   }

    // delete(id : number){
    //   Swal.fire({
    //     title: 'هل تريد مسح العنصر ؟',
    //     text: "لن يكون لك صلاحية إعادته مره اخرى",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     cancelButtonText: 'الغاء',
    //     confirmButtonText: 'امسح العنصر !'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.PartnersService.DeletePartner(id).subscribe((res) => {
    //         Swal.fire({
    //           icon: "success",
    //           title: "تم المسح بنجاح",
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //      this.getSuppliers();
    //       },(err) => {
    //         Swal.fire({
    //           icon: 'error',
    //           title: 'خطأ',
    //           text:err.error.message    
    //         })
    //       },() => {
    //         console.log("completed");
    //       })
    //     }
    //   }) 
    // }


}
